import { createContext } from 'react'

import type { AlarmCode } from '@/types/dashboard-types'

export const AlarmCodeContext = createContext<AlarmCode[]>([])
